import React from 'react';

import { uiHelpers } from '../../helpers';
import RelChart from './RelChart';

interface Props {
  item: any;
  priceRangeInterval?: string;
}

const RelPriceChart: React.FC<Props> = ({ priceRangeInterval, item }) => {
  if (!priceRangeInterval) {
    priceRangeInterval = '6m';
  }

  const {
    low,
    high,
    close,
    [`lowest${priceRangeInterval}`]: lowest,
    [`highest${priceRangeInterval}`]: highest,
  } = item;

  if (lowest === null) return <span>-</span>;

  return (
    <RelChart
      low={low}
      high={high}
      current={close}
      lowest={lowest}
      highest={highest}
      lowestLabel={uiHelpers.formatMoney(lowest)}
      highestLabel={uiHelpers.formatMoney(highest)}
    />
  );
};

export default React.memo(RelPriceChart);
